import React from 'react'
import { services } from '../data/ServiceData'
import * as Icons from 'lucide-react'
import { Wrench } from 'lucide-react'
import FadeIn from '../animations/FadeIn'
import { Link } from "react-router-dom";
import "./work.css"
import SEO from '../seo/SEO'

const Services = () => {
  return (
    <>
     <SEO
        title="Web Development Services | GraceTechie"
        description="We build websites, SaaS products, and custom digital solutions."
        keywords="web development, react developer, software agency"
        url="https://www.gracetechie.com.ng/#services"
        image="https://www.gracetechie.com.ng/og-image.png"
      />
    <section id='services' className='relative py-20 bg-black overflow-hidden'>
        <div className="absolute inset-0 overflow-hidden">
            <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-primary/20 opacity-20 rounded-full blur-3xl" />
            <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-primary/20 opacity-20 rounded-full blur-3xl" />
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-primary/10 opacity-20 rounded-full blur-3xl" />
        </div>

        <div 
            className="absolute inset-0 opacity-[0.03]"
            style={{
                backgroundImage: `linear-gradient(to right, white 1px, transparent 1px)
                                linear-gradient(to bottom, white 1px, transparent 1px)`,
                backgroundSize: '30px 30px'
            }}
        />

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <FadeIn delay={0}>
                <div className="text-center mb-16">
                    <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary/10 border border-primary/30 rounded-full mb-8">
                        <Wrench className='w-4 h-4 text-primary' />
                        <span className="text-sm text-primary font-medium tracking-wider uppercase">What We Do</span>
                    </div>
                    <h2 className="text-4xl lg:text-5xl font-normal text-white mg-4 max-w-2xl mx-auto">
                        Turning Ideas into Impact
                    </h2>
                    <p className="text-lg text-white/60 max-w-xl mx-auto text-center">
                        Practical, smart solutions designed to help you achieve your goals efficiently and effectively.
                    </p>
                </div>
            </FadeIn>

            <div className="services-first-two">
                {services.slice(0, 2).map((service, index) => {
                    const IconComponent = Icons[service.icon] || Icons.Code2;

                    return (
                    <FadeIn key={service.id} delay={100 + index * 100}>
                        <Link to={`/services/${service.id}`}>
                            <div className="service-card">
                                <div className="icon-wrapper">
                                    <IconComponent className="service-icon" />
                                </div>

                                <div className="service-content">
                                    <h3 className="service-title">{service.name}</h3>
                                    <p className="service-description">{service.description}</p>
                                </div>

                                <div className="service-overlay" />
                            </div>
                        </Link>
                    </FadeIn>
                    );
                })}
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                {services.slice(2).map((service, index) => {
                    const IconComponent = Icons[service.icon] || Icons.Code2;
                    return (
                        <FadeIn key={service.id} delay={300 + index * 100}>
                            <Link to={`/services/${service.id}`}>
                                <div className="group relative bg-white/5 border border-white/10 rounded-2xl p-6 hover:border-primary/30 transition-all duration-300 h-full service-card2">
                                    <div className="mb-4">
                                        <div className="icon-box">
                                            <IconComponent className="icon" />
                                        </div>
                                    </div>

                                    <div>
                                        <h3 className="text-lg font-semibold text-white mb-2 group-hover:text-[#b99fff] transition-colors duration-300">
                                            {service.name}
                                        </h3>
                                        <p className="text-sm text-white/60 leading-relaxed line-clamp-3">
                                            {service.description}
                                        </p>
                                    </div>

                                    <div className="absolute inset-0 bg-gradient-to-br from-primary/0 to-primary/0 group-hover:from-primary/5 group-hover:to-primary/5 rounded-2xl transition-all duration-300 pointer-events-none" />
                                </div>
                            </Link>
                        </FadeIn>
                    )
                })}
            </div>
        </div>
    </section>
    </>
  )
}

export default Services
